// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaTabsHeader_wrapper__0dSJe","content":"MediaTabsHeader_content__MK-19","link":"MediaTabsHeader_link__2g7Nh","active":"MediaTabsHeader_active__s8MAt"};